import styled, { css } from 'styled-components';
import PreviewPrice from 'gatsby-theme-vehicles/src/components/preview/components/price';

export default styled(PreviewPrice)`
  display: flex;
  gap: 0.25rem;
  align-items: baseline;
  font-weight: 700;

  ${({ $first }) => !$first && css`
    margin-top: 0.5rem;
  `}

  ${({ $variant }) => $variant === 'primary' && css`
    font-size: 1.75rem;
    .preview-prepend,
    .preview-append {
      font-size: 1rem;
    }
  `}
  ${({ $variant }) => $variant === 'secondary' && css`
    color: ${({ theme }) => theme.gray04};
  `}
`;
